
import React from 'react';

const CalendarPage: React.FC = () => {
  const daysInMonth = 31;
  const startOffset = 4; // Start on Thursday
  
  const days = [];
  for (let i = 0; i < startOffset; i++) {
    days.push(<div key={`offset-${i}`} className="bg-slate-50 dark:bg-slate-900/50 p-2 opacity-50 h-32 border border-slate-100 dark:border-slate-800"></div>);
  }
  for (let i = 1; i <= daysInMonth; i++) {
    const isToday = i === 8; // Simulate Jan 8th as current selection
    days.push(
      <div 
        key={i} 
        className={`p-2 relative border h-32 transition-all cursor-pointer ${
          isToday 
            ? 'bg-blue-50 dark:bg-blue-900/20 border-primary ring-2 ring-primary ring-inset' 
            : 'bg-white dark:bg-slate-900 border-slate-100 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800'
        }`}
      >
        <span className={`text-sm font-medium ${isToday ? 'text-primary font-bold' : 'text-slate-400 dark:text-slate-500'}`}>{i}</span>
        {isToday && (
          <div className="mt-2 space-y-1">
            <div className="bg-primary/10 dark:bg-primary/20 text-primary text-[10px] px-2 py-1 rounded flex items-center gap-1 font-bold">
              <span className="material-icons-round text-[12px]">group</span>
              PAX: 2/50
            </div>
            <div className="text-[9px] text-slate-500 dark:text-slate-400 font-medium truncate">Circuito Chico...</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="p-8 max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white">Calendário de Reservas</h1>
        <p className="text-slate-500 dark:text-slate-400 mt-1">Gerencie suas reservas e horários em diferentes visualizações</p>
      </div>

      <div className="flex flex-col xl:flex-row gap-6">
        <div className="flex-1 bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
          <div className="p-6 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="material-icons-round text-primary">calendar_month</span>
              <h2 className="text-lg font-semibold dark:text-white">Visualização Mensal</h2>
            </div>
            <div className="flex items-center gap-2">
              <button className="p-2 border border-slate-200 dark:border-slate-700 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                <span className="material-icons-round text-sm">chevron_left</span>
              </button>
              <select className="form-select text-sm border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 rounded-lg py-1.5 focus:ring-primary">
                <option>Janeiro</option>
                <option>Fevereiro</option>
              </select>
              <select className="form-select text-sm border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 rounded-lg py-1.5 focus:ring-primary">
                <option>2026</option>
                <option>2025</option>
              </select>
              <button className="p-2 border border-slate-200 dark:border-slate-700 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                <span className="material-icons-round text-sm">chevron_right</span>
              </button>
            </div>
          </div>
          
          <div className="grid grid-cols-7 border-b border-slate-200 dark:border-slate-800">
            {['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'].map(day => (
              <div key={day} className="py-3 text-center text-xs font-bold text-slate-500 dark:text-slate-400 uppercase bg-slate-50 dark:bg-slate-800/50">
                {day}
              </div>
            ))}
          </div>
          
          <div className="grid grid-cols-7 bg-slate-100 dark:bg-slate-800 gap-[1px]">
            {days}
          </div>
        </div>

        <aside className="w-full xl:w-80 space-y-6">
          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 p-6">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 bg-orange-100 dark:bg-orange-900/30 rounded-lg">
                <span className="material-icons-round text-orange-600 dark:text-orange-400">event</span>
              </div>
              <h3 className="text-lg font-bold dark:text-white">Quinta, 08 Jan</h3>
            </div>

            <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-4 mb-6">
              <div className="flex justify-between items-center mb-1">
                <span className="text-xs font-bold text-blue-800 dark:text-blue-300">Total Diário</span>
                <span className="bg-blue-100 dark:bg-blue-800 text-blue-700 dark:text-blue-200 px-2 py-0.5 rounded text-[10px] font-bold">1 tour</span>
              </div>
              <div className="flex items-baseline gap-2 mb-3">
                <span className="text-xl font-bold text-slate-900 dark:text-white">2 PAX</span>
                <span className="text-xs text-slate-500 dark:text-slate-400">/ 50 capacidade</span>
              </div>
              <div className="w-full bg-slate-200 dark:bg-slate-700 h-1.5 rounded-full overflow-hidden">
                <div className="bg-primary h-full rounded-full" style={{ width: '4%' }}></div>
              </div>
            </div>

            <div className="space-y-4">
              <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest">Tours ativos</h4>
              <div className="border border-slate-100 dark:border-slate-800 rounded-xl p-4">
                <div className="flex justify-between items-start mb-2">
                  <h5 className="font-bold text-sm dark:text-white">Circuito Chico</h5>
                  <span className="bg-slate-900 dark:bg-slate-700 text-white px-2 py-0.5 rounded text-[10px] font-bold">2/50</span>
                </div>
                <p className="text-[11px] text-slate-500 dark:text-slate-400 mb-2">4% ocupado</p>
                <div className="w-full bg-slate-100 dark:bg-slate-800 h-1.5 rounded-full">
                  <div className="bg-emerald-500 h-full rounded-full" style={{ width: '4%' }}></div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 p-6">
            <div className="flex items-center gap-3 mb-4">
              <span className="material-icons-round text-orange-400">error_outline</span>
              <h3 className="font-bold dark:text-white">Dicas IA</h3>
            </div>
            <p className="text-sm text-slate-500 dark:text-slate-400 italic">
              "Dia com baixa ocupação. Considere disparar promoções de última hora para hotéis parceiros ou reagrupar guias."
            </p>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default CalendarPage;
